import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BasePricingDetails } from './BasePricingDetails';

/**
 * Pricing surface for EXTERNAL_MANAGED: zero gateway down payment; total fee
 * comes from purchase pricing / product price for UI totals.
 */
export class ExternalManagedInstallmentPricingDetails extends BasePricingDetails {
  readonly amountToBePaid: number;
  readonly amountToBePaidInLeastSubunit: number;
  readonly minimumDownPaymentAmountToBePaid: number;
  readonly minimumDownPaymentAmountToBePaidInLeastSubunit: number;
  readonly minimumAmountToBePaid: number;
  readonly minimumAmountToBePaidInLeastSubunit: number;
  readonly totalPrincipalAmountToBePaid: number;
  readonly totalPrincipalAmountToBePaidInLeastSubunit: number;

  constructor(productDetails: GetProductDetailsResponseType) {
    super(productDetails);

    const pricingDetails =
      productDetails.product_purchase_details_for_user.pricing_details;
    const fromTotal = this.totalAmountToBePaid;
    const fromProductPrice = productDetails.product_details.product_price ?? 0;
    const principal =
      fromTotal > 0 ? fromTotal : fromProductPrice > 0 ? fromProductPrice : 0;
    const principalLeastSubunit =
      this.totalAmountToBePaidInLeastSubunit > 0
        ? this.totalAmountToBePaidInLeastSubunit
        : principal > 0
          ? Math.round(principal * 100)
          : 0;

    this.totalPrincipalAmountToBePaid = principal;
    this.totalPrincipalAmountToBePaidInLeastSubunit = principalLeastSubunit;
    this.minimumDownPaymentAmountToBePaid = 0;
    this.minimumDownPaymentAmountToBePaidInLeastSubunit = 0;
    this.minimumAmountToBePaid = 0;
    this.minimumAmountToBePaidInLeastSubunit = 0;
    this.amountToBePaid = 0;
    this.amountToBePaidInLeastSubunit = 0;
  }

  get isEligibleForFreeProduct(): boolean {
    return true;
  }
}
